import Rollbar from 'rollbar';

import { environment } from 'environments/environment';
import { runtimeEnv } from 'environments/runtime-env';
import { logRocketConfig } from 'third-party-integrations/log-rocket';

export const rollBarAccessToken = 'c5842baa1cd345b8a9b96fa4cb78d480';

const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const normalizeEndpoint = (endpoint: string) => endpoint.replace(UUID_PATTERN, ':id');

export const rollbarConfig = {
  accessToken: rollBarAccessToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: environment.env,
  payload: {
    environment: environment.env,
    client: {
      javascript: {
        source_map_enabled: true, // true by default
        //enable source map by providing the git sha
        code_version: runtimeEnv.REACT_APP_GIT_SHA,
        // Optionally have Rollbar guess which frames the error was
        // thrown from when the browser does not provide line
        // and column numbers.
        guess_uncaught_frames: true
      }
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform: (payload: any) => {
    const extra = payload?.body?.trace?.extra ?? payload?.body?.trace_chain?.[0]?.extra;
    const errorMessage = payload?.body?.trace?.exception?.message ?? payload?.body?.message?.body;
    if (extra?.endpoint && errorMessage) {
      const normalizedEndpoint = normalizeEndpoint(extra.endpoint);
      const endpointName = extra.endpointName ?? '';
      payload.fingerprint = `${errorMessage}:${endpointName}:${normalizedEndpoint}`;
      payload.title = `${errorMessage} - ${endpointName} - ${extra.endpoint}`;
    }
  }
};

export const rollbar = new Rollbar(rollbarConfig);

export const logError = (error: Error, data?: unknown) => {
  const typedData = data as Record<string, unknown> | undefined;
  const endpointInfo =
    typedData?.endpointName && typedData?.endpoint
      ? ` | ${typedData.endpointName} | ${normalizeEndpoint(String(typedData.endpoint))}`
      : '';

  // Slack message: Request failed with status code 500 | GcvServicesBanksApi | /banks/:id/sftp-upload-report/:id
  rollbar.error(`${error.message}${endpointInfo}`, error, {
    ...typedData,
    additional: logRocketConfig.session_url
  });
};
